export default "__VITE_ASSET__WgI1NRGO__"